import { PlayerSizesTypes } from '../../../../common/store/store.types';

interface PlayPauseButtonStyle {
  playPauseButtonStyle: { [key: string]: any };
  iconAndToolTipContainerStyle: { [key: string]: any };
}

const playPauseButton = {
  cursor: 'pointer',
  display: 'flex',
  smallAndMedium: {
    display: 'none',
  },
  mediumWithButton: {
    display: 'flex',
    margin: '0px 8px',
  },
  large: {
    margin: '0px 8px 0px 16px',
  },
  extraLarge: {
    margin: '0px 8px 0px 24px',
  },
};

const iconAndToolTipContainer = {
  position: 'relative',
  display: 'grid',
};

export const getPlayPauseButtonStyleObject = (playerSize: PlayerSizesTypes, isSplitView: boolean, showGalleryView: boolean): PlayPauseButtonStyle => {
  const mediumSize = playerSize === 'medium';
  const smallAndMediumSize = playerSize === 'small' || mediumSize;
  const splitViewMedium = mediumSize && isSplitView;
  const largeSize = playerSize === 'large';
  const extraLargeSize = playerSize === 'extraLarge';

  return {
    playPauseButtonStyle: [
      playPauseButton,
      smallAndMediumSize && playPauseButton.smallAndMedium,
      splitViewMedium && playPauseButton.mediumWithButton,
      mediumSize && showGalleryView && playPauseButton.mediumWithButton,
      largeSize && playPauseButton.large,
      extraLargeSize && playPauseButton.extraLarge,
    ],
    iconAndToolTipContainerStyle: {
      ...iconAndToolTipContainer,
    },
  };
};
